const producerTypes = {
    artistSlug: "artist",
    podcasterSlug: "podcaster",
};

export default producerTypes;
